import { useTranslation } from 'react-i18next'

const DPO_NAME = 'Dennis Meise'
const DPO_EMAIL = 'privacy@heliumtracker.io'

// Abschnitte mit gleichem Aufbau (Ueberschrift + Fliesstext). Der
// Datenschutzbeauftragte steht bewusst nicht in dieser Liste — er braucht einen
// Mailto-Link im Text und wird darum einzeln gerendert.
const SECTIONS = [
  'section1',
  'section2',
  'section3',
  'section4',
  'section5',
  // 09.2026: Reichweitenmessung und Werbung waren in dieser Erklärung gar nicht
  // beschrieben, obwohl v1 beides einsetzte. Mit der Rückkehr von Google
  // Analytics (Consent Mode v2) und AdSense muss es hier stehen.
  'section6',
  'section7',
] as const

export function PrivacyPage() {
  const { t } = useTranslation('legal')

  const emailLabel = t('privacy.dpo.emailLabel', { email: DPO_EMAIL })
  const emailLabelPrefix = emailLabel.split(DPO_EMAIL)[0]

  return (
    <article data-testid="privacy-page">
      <h2 className="section-heading">{t('privacy.heading')}</h2>
      <p className="muted">{t('privacy.subtitle')}</p>
      <p className="muted">{t('privacy.authoritativeNotice')}</p>

      {SECTIONS.map((section) => (
        <div key={section}>
          <h3 className="section-heading" style={{ marginTop: 24 }}>
            {t(`privacy.${section}.heading`)}
          </h3>
          <p>{t(`privacy.${section}.body`)}</p>
        </div>
      ))}

      <h3 className="section-heading" style={{ marginTop: 24 }}>
        {t('privacy.dpo.heading')}
      </h3>
      <p>
        {t('privacy.dpo.body', { dpo: DPO_NAME })}
        <br />
        {emailLabelPrefix}
        <a href={`mailto:${DPO_EMAIL}`}>{DPO_EMAIL}</a>
      </p>
    </article>
  )
}
